import { Card, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { dateTimeFormatV2 } from "../../util/DateUtil";

const useStyles = makeStyles({
  text: {
    textAlign: "center",
  },
});

const CatracaRegistroView = ({ catracaRegistro }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      alignContent={"center"}
      alignItems={"center"}
      justifyContent={"center"}
      component={Paper}
      sx={{ p: 2, backgroundColor: "#b9e2f5" }}
    >
      <Grid>
        <Typography variant="body1">
          Aluno: {catracaRegistro.aluno.codAlunoEscola} -{" "}
          {catracaRegistro.aluno.nome}
        </Typography>
      </Grid>
      <Grid>
        <Grid container spacing={3} direction="row">
          <Grid>
            <Card variant="outlined" sx={{ backgroundColor: "#dcf0fa" }}>
              <Grid container spacing={3} alignItems="center">
                <Grid size={12}>
                  <Typography className={classes.text} variant="h5">
                    {catracaRegistro.entradaSaida}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography className={classes.text} variant="subtitle1">
                    {dateTimeFormatV2(catracaRegistro.dataHora)}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography className={classes.text} variant="body1">
                    {catracaRegistro.entradaSaida === "ENTRADA" &&
                      "Entrada Liberada"}
                    {catracaRegistro.saiuSozinho &&
                      "Autorizado(a) a Sair Sozinho(a)"}
                    {catracaRegistro.usuarioRetirou &&
                      "Acompanhado(a) com " +
                        catracaRegistro.usuarioRetirou.nome +
                        "."}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CatracaRegistroView;
